import { Component, OnInit, Input, OnChanges, SimpleChanges, TemplateRef, ViewChild, EventEmitter, Output } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { AppService } from 'src/app/app.service';
import { ContentQuestionObj } from '../contentQuestion';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PaginationService } from 'src/app/PaginationService';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { messageService } from 'src/app/message.service';
import { StaticAuditTrailComponent } from 'src/app/support/static-audit-trail/static-audit-trail.component';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';

@Component({
  selector: 'app-content-assessment',
  templateUrl: './content-assessment.component.html',
  styleUrls: ['./content-assessment.component.scss']
})
export class AssessmentDialogComponent implements OnInit, OnChanges {


  @Input() contentData: any = {};
  @Input() trainingData: any = {};
  @Output() valueChange = new EventEmitter<{ questionObj: {}, isShowGrid: boolean }>;
  isProcessing = false;
  questionsList: ContentQuestionObj[] = [];
  questionData: ContentQuestionObj = {};
  questionImage: any;
  isFileValid = false;
  searchValue: string = '';
  operationFlag: any;
  previousQuestionData: any = {};
  title = "";
  dropDownForQuestionType: any = [];
  optionsList: any = [];
  columnList = [{ column: "Seq", width: "100px" }, { column: "Question", width: "600px" }, { column: "Type", width: "160px" }, { column: "Answer", width: "120px" }]
  showingRowsText = "Showing rows";
  perPage = 5;
  maxSize = 3;
  collectionSize: number;

  displayResultType: any;
  displaySuccessMessage: boolean;
  displayErrorMessage: boolean;
  openSnackbar: any;
  displayMessage: any;
  errorStatus: any;

  visibleAddButton: boolean = false;
  visibleEditButton: boolean = false;

  selectedQuestionType: any = null;
  selectedAnswer: any = [];

  selectedQuestionTypeValue: any = null;
  selectedAnswerValue: any = "";

  questionTypeDropdown: any = [];
  answerDropDown: any = [];

  answerTypeSearchText: string = '';
  answerSearchText: string = '';

  oddQuestionType: any = null;
  reorderQuestionsList: any = [];

  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }

  visibleAddOrEditQuestionPopup: MatDialogRef<TemplateRef<any>>;
  visibleDeleteQuestionPopup: MatDialogRef<TemplateRef<any>>;
  visibleReorderQuestionPopup: MatDialogRef<TemplateRef<any>>;
  visibleQustionOptionPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('addOrEditQuestionPopup', { static: true }) addOrEditQuestionPopup: TemplateRef<any>;
  @ViewChild('deleteQuestionPopup', { static: true }) deleteQuestionPopup: TemplateRef<any>;
  @ViewChild('reorderQuestionPopup', { static: true }) reorderQuestionPopup: TemplateRef<any>;
  @ViewChild('questionOptionPopup', { static: true }) questionOptionPopup: TemplateRef<any>;


  questionOptionPopupConfig = {
    width: '800px',
    minHeight: '20vh',
    maxHeight: '80vh',
    panelClass: 'my-dialog',
    disableClose: true,
    hasBackdrop: true,
    position: { top: '10px' },
  };

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };
  multiSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: true,
    allowSearchFilter: true,
    singleSelection: false
  };

  addOrEditQuestionPopupConfig = {
    width: '700px',
    minHeight: '40vh',
    maxHeight: '80vh',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  deleteQuestionPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  reorderQuestionPopupConfig = {
    width: '700px',
    minheight: '40vh',
    maxheight: '80vh',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };


  constructor(public appService: AppService, private readonly snackBar: MatSnackBar, public paginationService: PaginationService, public dialog: MatDialog, public message: messageService) {

  }

  ngOnInit(): void {
    this.appService.getCodeListsByGroupAndModule("QUESTION_TYPE", "TRN").subscribe({
      next: (data: any) => {
        this.dropDownForQuestionType = data;
        for (const element of this.dropDownForQuestionType) {
          this.questionTypeDropdown = this.questionTypeDropdown.concat({
            valueExp: element.codelistCode,
            displayExp: element.codelistName
          });
        }
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.isProcessing = true;
    this.appService.getContentAssessmentList(this.contentData['trainingId'],
      this.contentData['version'], this.contentData['contentId']).subscribe({
        next: (data: any) => {
          this.isProcessing = false;

          this.questionsList = data;
          this.collectionSize = this.questionsList.length;
        }, error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
  }

  refreshGrid() {
    this.isProcessing = true;
    this.appService.getContentAssessmentList(this.contentData['trainingId'],
      this.contentData['version'], this.contentData['contentId']).subscribe({
        next: (data: any) => {
          this.questionsList = data;
          this.isProcessing = false;
          this.collectionSize = this.questionsList.length;
        }, error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
  }

  pager: any = {};
  pagedItems: any[];
  makeStickyColumns: any;

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;

  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.questionsList.length, page, this.perPage, targetpage);
    this.pagedItems = this.questionsList.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  dataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked) {
      this.childCheckBoxs = true;
      for (const element of this.questionsList) {
        element.childCheckBoxs = true;
      }

    } else {
      this.childCheckBoxs = false;
      for (const element of this.questionsList) {
        element.childCheckBoxs = false;
      }
    }
  }

  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      list.childCheckBoxs = true;
    } else {
      list.childCheckBoxs = false;
    }
  }

  fileUploadPath: any = null;
  fileName: any = null;
  fileExtension: any = null;
  clearedQuestionImage = false;
  onFileSelected(event: any) {
    const file: File = event.target.files[0];

    if (file) {
      this.questionImage = file;
      
      this.questionData.questionImageExtn = (file.name.split('.').pop() ?? '').toLowerCase();
      let extension: any = (file.name.split('.').pop() ?? '').toLowerCase();
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const base64String = e.target.result.split(',')[1];
        this.questionData.questionImage = base64String;
      };
      reader.readAsDataURL(file);
      let date = new Date(Date.now());
      let fileName = "TC_" + this.contentData.contentId + "_" + `${date.getDate()}${date.getMonth() + 1}${date.getFullYear()}${date.getHours()}${date.getMinutes()}${date.getSeconds()}`;

      const formData = new FormData();
      formData.append('file', file ?? '');
      formData.append("pageName", "TMS");
      formData.append("fileName", fileName);
      formData.append("extension", extension);
      this.isProcessing = true;
      this.appService.fileUploadToServer(formData)
        .subscribe({
          next: (data: any) => {
            this.isProcessing = false;
            if (data.resultType == "S") {
              this.isFileValid = true;
              this.clearedQuestionImage = false;
              if(data.file) {
                this.questionData.questionImage = data.file;
              }
              this.fileExtension = extension;
              this.fileUploadPath = data.uploadPath;
              this.fileName = data.fileName;
            } else {
              this.isFileValid = false;
              this.questionImage = null;
              this.questionData.questionImageExtn = '';
              this.fileExtension = null;
              this.fileUploadPath = null;
              this.fileName = null;
              let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
                duration: 5000,
                data: {
                  message: data.result,
                  type: data.resultType == 'S' ? 'Success' : 'Error',
                  buttonLabel: "Ok"
                },
                horizontalPosition: 'center',
                verticalPosition: 'top',
                panelClass: data.resultType == 'S' ? 'Success' : 'Error',
              });
              sb.onAction().subscribe(() => {
                sb.dismiss();
              });
            }
          }, error: (error) => {
            this.displayMessage = error;
            this.displaySuccessMessage = false;
            this.displayErrorMessage = true;
            this.isProcessing = false;
            throw error;
          }
        })
    } else {
      this.questionImage = '';
      this.questionData.questionImageExtn = '';
      this.fileExtension = null;
      this.fileUploadPath = null;
      this.fileName = null;
    }
  }

  removeImage() {
    this.clearedQuestionImage = true;
    this.questionImage = null;
    this.questionData['questionImage'] = null;
    this.questionData['questionImageExtn'] = "";
  }

  resetFileUploadState() {
    this.questionImage = null;
    this.questionData.questionImageExtn = '';
    this.fileExtension = null;
    this.fileUploadPath = null;
    this.fileName = null;
    this.isFileValid = false;
  }

  fromSource = null;
  addQuestionFunc(event: any) {
    this.resetFileUploadState();
    event.stopPropagation();
    this.questionData = {
      question: "",
      questionType: "",
      answer: "",
      questionImage: null,
      questionImageExtn: "",
      trainingId: this.contentData['trainingId'],
      version: this.contentData['version'],
      contentId: this.contentData['contentId']
    };
    this.questionImage = null;
    this.isShowOptionsGrid = false;
    this.valueChange.emit({
      questionObj: { ...this.questionData },
      isShowGrid: this.isShowOptionsGrid
    }); this.selectedQuestionTypeValue = null;
    this.selectedAnswerValue = "";
    this.selectedAnswer = [];
    this.answerDropDown = [];
    this.selectedQuestionType = null;
    this.operationFlag = "ADD";
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    this.fromSource = null;
    if (this.questionsList.length > 0) {
      this.questionMode = null;
    } else {
      this.questionMode = "CREATE";
    }
    this.isManually = false;
    this.isFromFileUpload = false;
    this.title = "Add Question";
    this.visibleAddOrEditQuestionPopup = this.dialog.open(this.addOrEditQuestionPopup, this.addOrEditQuestionPopupConfig);
  }

  editQuestionFunc(question: any, event: any) {
    event.stopPropagation();
    this.isShowOptionsGrid = false;
    this.valueChange.emit({
      questionObj: { ...this.questionData },
      isShowGrid: this.isShowOptionsGrid
    }); this.questionData = { ...question };
    this.questionData.saveButtonForTraining = this.contentData.saveButtonForTraining;
    this.answerDropDown = [];
    this.selectedAnswer = [];
    this.isProcessing = true;
    this.isManually = true;
    this.questionImage = question.questionImage;
    this.appService.getQuestionOptionsList(this.contentData['trainingId'],
      this.contentData['version'], this.contentData['contentId'], question['questionId']).subscribe((data: any) => {
        this.isProcessing = false;
        this.optionsList = data;
        this.answerDropDown = [];
        for (const element of this.optionsList) {
          this.answerDropDown = this.answerDropDown.concat({
            valueExp: element.optionCode,
            displayExp: element.optionValue
          });
        }
        if (question.answer != null) {
          if (question.answer.includes(",")) { /* empty */ }
          this.selectedAnswer = question.questionType == 'Radio Button' ? question.answer : question.answer.split(",");
        }
      })

    if (question.questionType) {
      const matchingQuestion = this.questionTypeDropdown?.find((data: any) => data.valueExp == question.questionType)
      if (!matchingQuestion) {
        this.oddQuestionType = question.questionType;
        this.questionTypeDropdown.push({
          valueExp: question.questionType,
          displayExp: question.questionType
        })
      }
      this.selectedQuestionType = question.questionType;
    } else {
      this.selectedQuestionType = null;
    }

    this.selectedQuestionTypeValue = question['questionType'];
    this.selectedAnswerValue = question['answer'];
    this.operationFlag = "EDIT";
    this.visibleAddButton = false;
    this.visibleEditButton = true;
    this.title = "Update Question";
    this.visibleAddOrEditQuestionPopup = this.dialog.open(this.addOrEditQuestionPopup, this.addOrEditQuestionPopupConfig);
  }

  cancelAddAndEditFunction() {
    this.visibleAddOrEditQuestionPopup.close();
  }

  onQuestionTypeSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (item) {
        this.selectedQuestionTypeValue = item.valueExp;
        this.questionData['questionType'] = this.selectedQuestionTypeValue;
      } else {
        this.selectedQuestionTypeValue = null;
      }
    }
  }

  onQuestionTypeSelectOld(item: any) {
    this.selectedQuestionTypeValue = item.valueExp;
    this.questionData['questionType'] = this.selectedQuestionTypeValue;
  }
  onQuestionTypeRemoved(item: any) {
    this.selectedQuestionTypeValue = null;
  }

  onAnswerSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (item) {
        this.selectedAnswerValue = item?.valueExp ?? null;
      }
      setTimeout(() => {
        if (this.selectedAnswer) {
          this.answerSelection = this.answerDropDown.length == this.selectedAnswer.length;
        } else {
          this.answerSelection = false;
        }
      })
    }
  }

  onAnswerSelectOld(item: any) {
    this.selectedAnswerValue = item.valueExp;
  }
  onAnswerRemoved(item: any) { }

  @ViewChild('answer') answer: MatSelect;
  answerSelection = false;

  toggleAllSelection(value: any) {
    if (value == 'answer') {
      if (this.answerSelection) {
        this.answer.options.forEach((item: MatOption) => item.select());
      } else {
        this.answer.options.forEach((item: MatOption) => item.deselect())
        this.selectedAnswer = [];
      }
    }
  }
  questionMode: any = null;
  addAndEditFunction(question: any) {

    if (this.isManually) {
      this.isProcessing = true;
      if (question['question'] == "" || this.selectedQuestionTypeValue == null) {
        this.fieldValidation();
        this.isProcessing = false;
      } else {
        if (this.operationFlag == "ADD") {
          question['operation'] = "I";
        } else {
          question['operation'] = "U";
          delete question['createdOn'];
          delete question['updatedOn'];

        }
        question['answer'] = "";
        if (this.questionData.questionType == 'Radio Button') {
          if (this.selectedAnswer) {
            question.answer = this.selectedAnswer.length ? this.selectedAnswer : null;
          } else {
            question.answer = null;
          }

        }

        if (this.questionData.questionType == 'Check Box') {

          if (this.selectedAnswer) {
            question.answer = this.selectedAnswer.length ? this.selectedAnswer.join(',') : null;
          } else {
            question.answer = null;
          }
        }

        question['questionType'] = this.selectedQuestionTypeValue;
        const formData = new FormData();
        formData.append('file', this.questionImage);
        const json = JSON.stringify(question);
        const blob = new Blob([json], {
          type: 'application/json'
        });
        formData.append('dto', blob);
        this.appService.addOrUpdateContentQuestion(formData).subscribe({
          next: (data: any) => {
            this.isProcessing = false;
            if (data.resultType == "S") {
              this.fieldValidation();
              this.visibleAddOrEditQuestionPopup.close();
              this.isProcessing = true;
              this.appService.getContentAssessmentList(this.contentData['trainingId'],
                this.contentData['version'], this.contentData['contentId']).subscribe({
                  next: (data: any) => {
                    this.isProcessing = false;

                    this.questionsList = data;
                    this.collectionSize = this.questionsList.length;
                  }, error: (error) => {
                    this.isProcessing = false;
                    throw error;
                  }
                });
            }
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: 5000,
              data: {
                message: data.result,
                type: data.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok"
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: data.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
            this.isProcessing = false;
          }, error: (error) => {
            this.displayMessage = error;
            this.displaySuccessMessage = false;
            this.displayErrorMessage = true;
            this.isProcessing = false;
            throw error;
          }
        });
      }

      setTimeout(() => {
        this.isProcessing = false;
      }, 3000);
    } else if (this.fileUploadPath == null) {
      alert("Please upload file!");
    } else {
      let data = {
        trainingId: this.contentData.trainingId,
        version: this.contentData.version,
        contentId: this.contentData.contentId,
        filePath: this.fileUploadPath,
        fileName: this.fileName,
        fileExtn: this.fileExtension,
        mode: this.questionMode
      }
      this.appService.addQuestionsThroughFileUpload(data).subscribe({
        next: (data: any) => {
          this.isProcessing = false;
          this.visibleAddOrEditQuestionPopup.close();
          this.isProcessing = true;
          this.appService.getContentAssessmentList(this.contentData['trainingId'],
            this.contentData['version'], this.contentData['contentId']).subscribe((data: any) => {
              this.isProcessing = false;

              this.questionsList = data;
              this.collectionSize = this.questionsList.length;

            })
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: data.result,
              type: data.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: data.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        }, error: (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  question: any;
  questionType: any;

  questionRequiredMsg: any;
  questionTypeRequiredMsg: any;

  fieldValidation() {
    this.question = document.getElementById('question') as HTMLInputElement;
    this.questionType = document.getElementById('questionType') as HTMLInputElement;

    this.questionRequiredMsg = document.getElementById('question-required-msg') as HTMLInputElement;
    this.questionTypeRequiredMsg = document.getElementById('questionType-required-msg') as HTMLInputElement;

    if (this.questionData.question == "") {
      this.question.style.border = '1px solid red';
      this.questionRequiredMsg.style.display = 'block';
    } else {
      this.question.style.border = 'none';
      this.questionRequiredMsg.style.display = 'none';
    }
    if (this.selectedQuestionTypeValue == null) {
      this.questionType.style.border = '1px solid red';
      this.questionTypeRequiredMsg.style.display = 'block';
    } else {
      this.questionType.style.border = 'none';
      this.questionTypeRequiredMsg.style.display = 'none';
    }
  }
  isShowOptionsGrid = false;
  openOptionsGrid(question: any) {
    this.isShowOptionsGrid = true;
    this.valueChange.emit({ questionObj: question, isShowGrid: this.isShowOptionsGrid });
  }

  openDeletePopup(question: any, event: any) {
    event.stopPropagation();
    this.isShowOptionsGrid = false;
    this.valueChange.emit({
      questionObj: { ...this.questionData },
      isShowGrid: this.isShowOptionsGrid
    }); this.questionData = question;
    this.questionData.saveButtonForTraining = this.contentData.saveButtonForTraining;
    this.questionData['deleteReason'] = "";
    this.title = "Delete Question";
    this.visibleDeleteQuestionPopup = this.dialog.open(this.deleteQuestionPopup, this.deleteQuestionPopupConfig);
  }

  cancelDeleteFunction() {
    this.visibleDeleteQuestionPopup.close();
  }

  deleteFunction() {
    this.isProcessing = true;
    if (this.questionData['deleteReason'] == "") {
      this.deleteValidation();
      this.isProcessing = false;
    } else {
      delete this.questionData['createdOn'];
      delete this.questionData['updatedOn'];
      this.appService.deleteContentQuestion(this.questionData).subscribe({
        next: (data: any) => {
          this.isProcessing = false;
          if (data.resultType == "S") {
            this.deleteValidation();

          }
          this.visibleDeleteQuestionPopup.close();
          this.isProcessing = true;
          this.appService.getContentAssessmentList(this.contentData['trainingId'],
            this.contentData['version'], this.contentData['contentId']).subscribe((data: any) => {
              this.isProcessing = false;

              this.questionsList = data;
              this.collectionSize = this.questionsList.length;

            })
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: data.result,
              type: data.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: data.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        }, error: (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        }
      });

    }

  }

  deleteReason: any;

  deleteReasonRequiredMsg: any;

  deleteValidation() {
    this.deleteReason = document.getElementById('deleteReason') as HTMLInputElement;

    this.deleteReasonRequiredMsg = document.getElementById('deleteReason-required-msg') as HTMLInputElement;

    if (this.questionData.deleteReason == "") {
      this.deleteReason.style.border = '1px solid red';
      this.deleteReasonRequiredMsg.style.display = 'block';
    } else {
      this.deleteReason.style.border = 'none';
      this.deleteReasonRequiredMsg.style.display = 'none';
    }
  }

  callReorderFunc() {
    this.title = "Reorder Question";
    this.reorderQuestionsList = structuredClone(this.questionsList);
    for (let i = 0; i < this.reorderQuestionsList.length; i++) {
      this.reorderQuestionsList[i].newSeq = i + 1;
    }
    this.visibleReorderQuestionPopup = this.dialog.open(this.reorderQuestionPopup, this.reorderQuestionPopupConfig);
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.reorderQuestionsList, event.previousIndex, event.currentIndex);
    for (let i = 0; i < this.reorderQuestionsList.length; i++) {
      this.reorderQuestionsList[i].newSeq = i + 1;
    }
  }

  reorderQuestionFunction() {
    this.isProcessing = true;
    for (let i = 0; i < this.reorderQuestionsList.length; i++) {
      let data = {
        trainingId: this.reorderQuestionsList[i]['trainingId'],
        version: this.reorderQuestionsList[i]['version'],
        contentId: this.reorderQuestionsList[i]['contentId'],
        questionId: this.reorderQuestionsList[i]['questionId'],
        seq: this.reorderQuestionsList[i]['newSeq'],
      }
      this.appService.reorderContentQuestion(data).subscribe((data: any) => {
        if (i == this.reorderQuestionsList.length - 1) {
          this.isProcessing = false;
          if (data.resultType == "S") {
            this.visibleReorderQuestionPopup.close();
            this.isProcessing = true;
            this.appService.getContentAssessmentList(this.contentData['trainingId'],
              this.contentData['version'], this.contentData['contentId']).subscribe((data: any) => {
                this.isProcessing = false;

                this.questionsList = data;
                this.collectionSize = this.questionsList.length;

              })
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: data.result,
              type: data.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: data.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
        }
      })
    }
  }

  cancelReorderFunction() {
    this.visibleReorderQuestionPopup.close();
  }

  previousQuestionDataForCheck: any = {};
  openOptionsPopup(questionData: any, event: any) {
    this.isShowOptionsGrid = true;
    questionData.childCheckBoxs = true;
    this.previousQuestionDataForCheck = { ...questionData };
    this.questionData = { ...questionData };
    this.questionData.saveButtonForTraining = this.contentData.saveButtonForTraining;
    this.visibleQustionOptionPopup = this.dialog.open(this.questionOptionPopup, this.questionOptionPopupConfig);
  }

  cancelOptionPopup() {
    this.visibleQustionOptionPopup.close();
    this.previousQuestionDataForCheck.childCheckBoxs = false;
  }

  @ViewChild(StaticAuditTrailComponent) staticAuditTrailComponent!: StaticAuditTrailComponent;

  openAuditTrail(viewType: any, question: any) {
    if (viewType == 'overAll') {
      this.message.tableOrView_Name = "TMS_TRAINING_QUESTIONS_AU_VW";
      this.message.columnList_DB = "CREATED_TS,END_TS,ACTION_FLAG,SEQ,QUESTION,QUESTION_TYPE,QUESTION_IMAGE,QUESTION_IMAGE_EXTN,ANSWER,VERSION,CREATED_ON,CREATED_BY_USER,UPDATED_ON,UPDATED_BY_USER,DELETED_BY_USER,DELETED_REASON";
      this.message.columnList_UI = "Created Timestamp,End Timestamp,Action Flag,Seq,Question,Question Type,Question Image,Question Image Extension,Answer,Version,Created On,Created By,Updated On,Updated By,Deleted By,Deleted Reason";
      this.message.whereClause_AU = " AND TRAINING_ID=" + this.contentData.trainingId + " AND CONTENT_ID=" + this.contentData.contentId + " AND VERSION=" + this.contentData.version;
      this.message.columnList_Report = "Created Timestamp,End Timestamp,Action Flag,Seq,Question,Question Type,Question Image,Question Image Extension,Answer,Version,Created On,Created By,Updated On,Updated By,Deleted By,Deleted Reason";
      this.message.whereClause_Report = " WHERE TRAINING_ID=" + this.contentData.trainingId + " AND CONTENT_ID=" + this.contentData.contentId + " AND VERSION=" + this.contentData.version;
      this.message.report_And_Popup_Name = "Training Questions Audit Trail";
      this.staticAuditTrailComponent.triggerTrail(question);
    } else {
      this.message.tableOrView_Name = "TMS_TRAINING_QUESTIONS_AU_VW";
      this.message.columnList_DB = "CREATED_TS,END_TS,ACTION_FLAG,SEQ,QUESTION,QUESTION_TYPE,QUESTION_IMAGE,QUESTION_IMAGE_EXTN,ANSWER,VERSION,CREATED_ON,CREATED_BY_USER,UPDATED_ON,UPDATED_BY_USER";
      this.message.columnList_UI = "Created Timestamp,End Timestamp,Action Flag,Seq,Question,Question Type,Question Image,Question Image Extension,Answer,Version,Created On,Created By,Updated On,Updated By";
      this.message.whereClause_AU = " AND TRAINING_ID=" + question.trainingId + " AND CONTENT_ID=" + question.contentId + " AND QUESTION_ID=" + question.questionId + " AND VERSION=" + question.version;
      this.message.columnList_Report = "Created Timestamp,End Timestamp,Action Flag,Seq,Question,Question Type,Question Image,Question Image Extension,Answer,Version,Created On,Created By,Updated On,Updated By";
      this.message.whereClause_Report = " WHERE TRAINING_ID=" + question.trainingId + " AND CONTENT_ID=" + question.contentId + " AND QUESTION_ID=" + question.questionId + " AND VERSION=" + question.version;
      this.message.report_And_Popup_Name = "Training Questions Audit Trail";
      this.staticAuditTrailComponent.triggerTrail(question);
    }
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};

  openReport(reportType: string) {
    this.excelPdf.tableOrView_Name = "TMS_TRAINING_QUESTIONS_VW";
    this.excelPdf.columnList_DB = "SEQ,QUESTION,QUESTION_TYPE,QUESTION_IMAGE_EXTN,ANSWER,VERSION,CREATED_ON,CREATED_BY_USER,UPDATED_ON,UPDATED_BY_USER";
    this.excelPdf.columnList_Report = "Seq,Question,Question Type,Question Image Extension,Answer,Version,Created On,Created By,Updated On,Updated By";
    this.excelPdf.whereClause_Report = " WHERE TRAINING_ID=" + this.contentData.trainingId + " AND CONTENT_ID=" + this.contentData.contentId + " AND VERSION=" + this.contentData.version;
    this.excelPdf.reportType = 'Static';
    this.excelPdf.reportName = 'Training Questions Report [' + this.contentData.contentName + ']';
    this.excelPdf.dropDown = this.excelPdf.columnList_Report?.split(',');
    this.excelPdfComponent.openReportPopup(reportType);
  }


  isManually = false;
  isFromFileUpload = false;
  onTypeChanged(value: any) {
    if (value == "manually") {
      this.isManually = true;
      this.isFromFileUpload = false;
    } else {
      this.isManually = false;
      this.isFromFileUpload = true;
    }
  }

  onModeChanged(value: any) {
    this.questionMode = value;
  }

}
